var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVisa = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 68,
    viewBox: "0 0 105 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.188,
    height: 65.188,
    x: 1.406,
    y: 1.406,
    fill: "#FFF",
    stroke: "#979797",
    strokeWidth: 2.813,
    rx: 5.625
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#16216A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.077 1.507c-1.325-.5-3.398-1.04-5.99-1.04-6.6 0-11.252 3.344-11.292 8.14-.039 3.54 3.32 5.519 5.853 6.7 2.6 1.208 3.48 1.978 3.466 3.058-.02 1.652-2.08 2.406-4.002 2.406-2.668 0-4.087-.375-6.285-1.294l-.86-.388-.938 5.52c1.557.687 4.444 1.283 7.442 1.313 7.024 0 11.582-3.305 11.634-8.426.023-2.8-1.752-4.937-5.607-6.698-2.338-1.142-3.767-1.902-3.757-3.057 0-1.024 1.216-2.12 3.829-2.12 2.184-.036 3.77.444 5 .941l.598.287.909-5.342M77.204.92h-5.16c-1.599 0-2.796.442-3.495 2.045l-9.924 22.598h7.017s1.144-3.038 1.406-3.703c.765 0 7.58.01 8.554.01.2.862.814 3.693.814 3.693h6.2L77.204.921zm-8.237 15.898c.556-1.425 2.662-6.899 2.662-6.899-.036.07.55-1.425.883-2.353l.454 2.126s1.282 5.888 1.55 7.126h-5.549zM23.562.914l-6.54 16.816-.7-3.417c-1.213-3.936-5.009-8.208-9.25-10.344l5.977 21.564 7.07-.006L30.638.914h-7.076",
    transform: "translate(10.5 19.889)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.954.901H.176l-.082.51c8.381 2.04 13.93 6.978 16.229 12.902L13.98 2.981c-.405-1.563-1.576-2.024-3.027-2.08M29.167 25.553L33.342.898 40.026.898 35.84 25.553 29.167 25.553",
    transform: "translate(10.5 19.889)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visa.705ba60a.svg";
export { ForwardRef as ReactComponent };